import type { JobAnalysisCoverage } from '@/hooks/use-job-analysis-coverage'
import type { JobProspectMatch } from '@/hooks/use-job-prospect-matches'
import { normalizeSkillKey } from '@/lib/talent-browse-filters'

export const COVERAGE_GAP_THRESHOLD = 0.5

const GAP_CLOSER_COVERAGE_RATIO = COVERAGE_GAP_THRESHOLD

export function gapClosingSkillKeys(coverage: JobAnalysisCoverage | null | undefined): Set<string> {
  const keys = new Set<string>()
  for (const requirement of coverage?.requirements ?? []) {
    if (requirement.total <= 0) continue
    if (requirement.covered / requirement.total >= GAP_CLOSER_COVERAGE_RATIO) continue
    const key = normalizeSkillKey(requirement.label)
    if (key) keys.add(key)
  }
  return keys
}

export function prospectHasGapClosingSkill(
  match: JobProspectMatch,
  gapClosingKeys: Set<string>,
): boolean {
  if (gapClosingKeys.size === 0) return false
  return (match.top_skills ?? []).some((skill) => gapClosingKeys.has(normalizeSkillKey(skill)))
}

export function sortProspectsWithGapClosersFirst(
  matches: JobProspectMatch[],
  coverage: JobAnalysisCoverage | null | undefined,
): JobProspectMatch[] {
  const gapClosingKeys = gapClosingSkillKeys(coverage)
  if (gapClosingKeys.size === 0) return matches

  return [...matches].sort((left, right) => {
    const leftGap = prospectHasGapClosingSkill(left, gapClosingKeys)
    const rightGap = prospectHasGapClosingSkill(right, gapClosingKeys)
    if (leftGap !== rightGap) return leftGap ? -1 : 1
    return left.rank - right.rank
  })
}
